import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';
import { readinessApi } from '../api/readiness';

/**
 * The readiness formula definition (pillars, weights, tier cutoffs).
 *
 * It is static per API build — the server sends `Cache-Control: max-age=86400`
 * — so it is fetched once per session and shared by the student and org views.
 * Any surface that needs to explain a score reads it from here rather than
 * restating weights in copy.
 */
export function useReadinessFormula() {
  return useQuery({
    queryKey: queryKeys.lms.readinessFormula(),
    queryFn: async () => {
      const { data } = await readinessApi.getFormula();
      return data;
    },
    staleTime: 24 * 60 * 60_000,
    gcTime: 24 * 60 * 60_000,
  });
}
